import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { LoginBg, SetUp } from '../../components';
import { updateLoginInfoAction, updateWardinfoAction } from '../../redux/actions';
import rou from '../../router';
import { LOGIN_INFO, WARD_INFO } from '../../comm/constant';
import { defauleSkipUrlRole, loginAndRedirect } from '../../utils/check';
import { userRoleFunc, userRoleList } from '../../utils/userRole';
import { i18n } from '../../language';
import { mutationUpdateOtherLoginInfo } from '../../utils/handleUpdateOtherLoginInfo';

function PageSetup({ rouList, loginInfo, updateWardinfo, history, wardInfo, updateLoginInfo, userRole }) {
  const isHAandWardsEmpty = () => {
    const hospWard = userRoleList.getHospWard(userRole, loginInfo.hospitalId, loginInfo.wardId, loginInfo.userId);
    return userRoleFunc.isHospitalAdmin(hospWard) && userRoleFunc.isWardEmpty(hospWard);
  };

  useEffect(() => {
    if (
      wardInfo.flag ||
      userRoleFunc.isSuperAdmin(
        userRoleList.getHospWard(userRole, loginInfo.hospitalId, loginInfo.wardId, loginInfo.userId)
      ) ||
      isHAandWardsEmpty()
    ) {
      history.replace(defauleSkipUrlRole(userRole, loginInfo.hospitalId, loginInfo.wardId, history.location.pathname));
    }
  }, [rouList]);

  const setValueUseWardInfo = (hospitalName, wardName, hospitalId, wardId, hospCode) => {
    let result = null;
    const activeUserRole = userRoleList.filterInActive(userRole);
    if (!userRoleFunc.isSuperAdmin(userRole)) {
      const wardInfoMaxRole = userRoleList.getMaxRoleUseHospIdAndWardId(activeUserRole, hospitalId, wardId);
      if (wardInfoMaxRole) {
        result = {
          hospitalId: hospitalId ?? null,
          hospitalName: hospitalName ?? null,
          userId: wardInfoMaxRole?.userId ?? null,
          wardId: wardId ?? null,
          wardName: wardName ?? null,
          hospCode: hospCode ?? null,
        };
      }
    }
    return result;
  };

  const submitClick = (callback) => {
    const { hospitalName, wardName, hospitalId, wardId, hospCode } = callback;
    updateWardinfo(true, hospitalName, wardName, hospitalId, wardId, hospCode);
    localStorage.setItem(
      WARD_INFO,
      JSON.stringify({
        hospitalId,
        hospitalName,
        wardName,
        wardId,
        hospCode,
      })
    );
    const temp = setValueUseWardInfo(hospitalName, wardName, hospitalId, wardId, hospCode);
    if (temp) {
      const loginObj = JSON.parse(localStorage.getItem(LOGIN_INFO));
      localStorage.setItem(LOGIN_INFO, JSON.stringify({ ...loginObj, ...temp }));
      mutationUpdateOtherLoginInfo();
      updateLoginInfo({ ...loginInfo, ...temp });
    } else {
      history.push(rou.defaultRou.path);
    }
    loginAndRedirect();
  };

  return (
    <LoginBg title={i18n.t('LOGIN_PAGE_TITLE')} subTitle={i18n.t('LOGIN_PAGE_SUBTITLE')}>
      <SetUp submitClick={submitClick} />
    </LoginBg>
  );
}

export default connect(
  (state) => ({
    loginInfo: state.loginInfo,
    wardInfo: state.wardInfo,
    userRole: state.userRole,
    rouList: state.rouList,
  }),
  {
    updateWardinfo: updateWardinfoAction,
    updateLoginInfo: updateLoginInfoAction,
  }
)(PageSetup);
